export default {
  title: 'Dane logowania personelu',
  form: {
    username: {
      label: 'Nazwa użytkownika',
      placeholder: 'Nazwa użytkownika',
    },
    password: {
      label: 'Hasło',
      placeholder: 'Hasło',
    },
    button: {
      title: 'Zapisz',
    },
    success: 'Informacje zostały pomyślnie zapisane.',
  },
};
